import api from '../..//services/api';
import App from '@/main'
import * as types from '../types';

export default {
    namespaced: true,
    state: {
        loading: false,
        user: localStorage.getItem('user') || ''
    },
    getters: {
        loading: state => state.loading,
        user: state => state.user
    },
    mutations: {
        [types.SET_LOADING]: state => state.loading = true,
        [types.REMOVE_LOADING]: state => state.loading = false,
        [types.AUTH_SUCCESS]: (state, payload) => {
            state.user = JSON.stringify(payload);
            localStorage.setItem('user', JSON.stringify(payload));
            App.$http.defaults.headers.common["x-auth-token"] = payload.token;
            App.$http2.defaults.headers.common["x-auth-token"] = payload.token;
        },
        [types.AUTH_FAIL]: state => {
            state.user = '';
            api.defaults.headers.common['x-auth-token'] ='';
            localStorage.clear();
        }, 
    },
    actions: {
        [types.SIGN_IN]: async ({commit}, payload) => {
            commit(types.SET_LOADING);
            try {
                let response = await api.post('/auth/signin', JSON.stringify(payload));
                if(response.status === 200){
                    commit(types.AUTH_SUCCESS, response.data);
                    commit(`global/${types.SET_ROUTE}`, '/edi-invoices' ,{ root: true });
                }
            } catch (error) {
                if (error.status === 500) {
                    let ERROR = error.data.errors;
                    ERROR.map(err => {
                        commit(`global/${types.SET_NOTIFICATION}`, { type: 'error', message: err.msg },{ root: true });
                    });
                }
                if (error.status === 400) {
                    commit(`global/${types.SET_NOTIFICATION}`, { type: 'error', message: error.data.err.msg },{ root: true });
                }
                commit(types.AUTH_FAIL);
            }finally{
                commit(types.REMOVE_LOADING);
            }
        },
        [types.SIGN_UP]: async ({commit}, payload) => {
            commit(types.SET_LOADING);
            try {
                let response = await api.post('/auth/signup', JSON.stringify(payload));
                if(response.status === 200){
                    commit(types.AUTH_SUCCESS, response.data);
                    commit(`global/${types.SET_ROUTE}`, '/edi-invoices' ,{ root: true });
                }
            } catch (error) {
                if (error.status === 500) {
                    let ERROR = error.data.errors;
                    ERROR.map(err => {
                        commit(`global/${types.SET_NOTIFICATION}`, { type: 'error', message: err.msg },{ root: true });
                    });
                }
                if (error.status === 400) {
                    commit(`global/${types.SET_NOTIFICATION}`, { type: 'error', message: error.data.err.msg },{ root: true });
                }
                commit(types.AUTH_FAIL);
            }finally{
                commit(types.REMOVE_LOADING);
            }
        },
        [types.SIGN_OUT]: ({commit}) => {
            commit(types.SET_LOADING);
            commit(types.AUTH_FAIL);
            commit(`global/${types.SET_ROUTE}`, '/signin', { root: true });
            commit(types.REMOVE_LOADING);
        }
    }
}